<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY + 'orderNo')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY + 'orderNo'))"
                       v-model='queryParam.orderNo'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('phoneNo')">
              <a-input
                :placeholder="$t('enter') + ' ' + transformStringToLow($t('phoneNo'))"
                v-model='queryParam.mobileNo'></a-input>
            </a-form-item>
          </a-col>
          <template v-if='toggleSearchStatus'>
            <a-col :md='8' :sm='12'>
<!--              <a-form-item :label="$t('customer.AadhaarName')">-->
              <a-form-item label="姓名">
                <a-input :placeholder="$t('enter') + ' ' + transformStringToLow('姓名')"
                         v-model='queryParam.aadhaarName'></a-input>
              </a-form-item>
            </a-col>
            <a-col :md='6' :sm='8'>
              <a-form-item :label="$t(I18N_KEY + 'loanStatus')">
                <dict-select
                  v-model='queryParam.loanStatus'
                  :dict-code='DICT_CODE.LOAN_STATUS'
                  :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                />
              </a-form-item>
            </a-col>

            <a-col :md='6' :sm='8'>
              <a-form-item :label="$t(I18N_KEY + 'approvalStatus')">
                <dict-select
                  v-model='queryParam.approvalStatus'
                  :dict-code='DICT_CODE.ORDER_STATUS'
                  :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                />
              </a-form-item>
            </a-col>
            <a-col :md='6' :sm='8'>
              <a-form-item :label="$t(I18N_KEY + 'settlementStatus')">
                <dict-select
                  v-model='queryParam.settleStatus'
                  :dict-code='DICT_CODE.SETTLE_STATUS'
                  :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                >
                </dict-select>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'applicationTime')">
                <a-range-picker
                  v-model='queryParam.createdTime'
                  format='YYYY-MM-DD' />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
               <a @click='handleToggleSearch' style='margin-left: 8px'>
                     {{ $t(toggleSearchStatus ? 'hide' : 'show') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        :scroll="{ x: 1700 }"
        bordered>
        <Dict slot='loanStatus' slot-scope='text' :dict-code='DICT_CODE.LOAN_STATUS' :value='text' />
        <Dict slot='approvalStatus' slot-scope='text' :dict-code='DICT_CODE.ORDER_STATUS' :value='text' />
        <Dict slot='settleStatus' slot-scope='text' :dict-code='DICT_CODE.SETTLE_STATUS' :value='text' />
        <Dict slot='overdueStatus' slot-scope='text' :dict-code='DICT_CODE.OVERDUE_STATUS' :value='text' />
        <span slot='action' slot-scope='text, record'>
          <!-- slot-scope="text, record" -->
          <!--<a @click="handleDetail(record)">{{ $t('view') }}</a>-->
          <a @click='handleEdit(record)'>
            编辑
          </a>
          <a-divider type='vertical' />
          <a-popconfirm title='确定清除吗?' @confirm='() =>handleClear(record.id)'>
            <a>清数据</a>
          </a-popconfirm>
          <a-divider type='vertical' />
          <a @click="showResetModal(record.id)">重置还款状态</a> <!-- 直接点击触发弹窗 -->
          <br/>
          <a @click="showDeductionFeeModal(record.id)">减免金额设置</a> <!-- 直接点击触发弹窗 -->
          <a-divider type='vertical' />
          <a @click="downLoadData(record, '1')" type='button' icon='download' style='margin-left: 8px'>导json</a>
          <a-divider type='vertical' />
          <a @click="downLoadData(record, '0')" type='button' icon='download' style='margin-left: 8px'>原始json</a>
          <a-divider type='vertical' />
           <a @click='handleClearRedis(record.id)'>
            清Redis
            </a>
        </span>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
      <a-modal
        v-model="resetModalVisible"
        title="重置还款状态"
        @ok="handleResetConfirm"
        @cancel="resetModalVisible = false"
      >
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 16px">
          <span style="white-space: nowrap">原orderNo:</span>
          <a-input
            v-model="orderNo"
            placeholder="请输入原orderNo"
          />
        </div>
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 16px">
          <span style="white-space: nowrap">payoutID:</span>
          <a-input
            v-model="payoutId"
            placeholder="请输入指定的payoutId(非特殊场景无需填写)"
          />
        </div>
      </a-modal>
      <a-modal
        v-model="deductionFeeModalVisible"
        title="减免金额设置"
        @ok="handleDeductionFeeConfirm"
        @cancel="deductionFeeModalVisible = false"
      >
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 16px">
          <span style="white-space: nowrap">减免金额:</span>
          <a-input
            v-model="deductionFee"
            placeholder="请输入减免金额"
          />
        </div>
      </a-modal>
    </div>
    <v-modal
      v-model='visible'
      :title="$t(I18N_KEY + 'orderDetail')">
      <div style='padding: 20px;'>
        <order-detail v-if='visible' :orderId='orderId' :custInfoId='custInfoId' />
      </div>
    </v-modal>
    <test-order-modal ref='modalForm' @ok='modalFormOk'></test-order-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getPlatformAllOrderList, clearOrderForTest ,clearRedisOrderData,getJsonData,orderReset,orderDeductionFee} from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import vModal from '../modules/Modal'
import OrderDetail from '../order/OrderDetail'
import moment from 'moment'
import TestOrderModal from './modules/TestOrderModal'
import exportFile from '@/webpublicapi/exportFile'


const I18N_KEY = 'order.'
export default {
  name: 'TestOrderList',
  components: {
    Dict,
    DictSelect,
    vModal,
    OrderDetail,
    TestOrderModal
  },
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      resetModalVisible: false, // 控制弹窗显示
      deductionFeeModalVisible: false,
      orderNo: "",
      payoutId:"",
      deductionFee: "",
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      // 查询条件
      queryParam: {
        'orderNo': '',
        'mobileNo': '',
        'appssid': '',
        'aadhaarName': '',
        'createdTime': undefined,
        'loanStatus': '',
        'approvalStatus': '',
        'settleStatus': ''
      },
      loading: false,
      // 表头
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY + 'orderNo'),
          align: 'left',
          dataIndex: 'orderNo'
        },
        {
          title: this.$t('phoneNo'),
          align: 'left',
          dataIndex: 'mobileNo'
        },
        {
          title: '盘号',
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: this.$t(I18N_KEY + 'applicationAmount'),
          align: 'left',
          dataIndex: 'applyAmt'
        },
        {
          title: this.$t(I18N_KEY + 'deductionFee'),
          align: 'left',
          dataIndex: 'deductionFee'
        },
        {
          title: this.$t(I18N_KEY + 'deadline'),
          align: 'left',
          dataIndex: 'duration'
        },
        {
          title: this.$t(I18N_KEY + 'loanStatus'),
          align: 'left',
          dataIndex: 'loanStatus',
          scopedSlots: { customRender: 'loanStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'approvalStatus'),
          align: 'left',
          dataIndex: 'approvalStatus',
          scopedSlots: { customRender: 'approvalStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'settlementStatus'),
          align: 'left',
          dataIndex: 'settleStatus',
          scopedSlots: { customRender: 'settleStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'overdueStatus'),
          align: 'left',
          dataIndex: 'overdueStatus',
          scopedSlots: { customRender: 'overdueStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'applicationTime'),
          align: 'left',
          dataIndex: 'createdTime'
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 350,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    // this.loadData(1)
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      if (!this.queryParam.mobileNo.trim()) {
        alert('手机号不能为空')
        self.loadData()
        return false
      }
      // if(!this.queryParam.mobileNo.startsWith("182") && !this.queryParam.mobileNo.startsWith("183")){
      //   alert('手机号必须为182/183开头');
      //   self.loadData();
      //   return false;
      // }
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      getPlatformAllOrderList(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { createdTime } = this.queryParam
      const data = {
        ...this.queryParam,
        applyDateStart: createdTime && this.transformTime(createdTime[0]),
        applyDateEnd: createdTime && this.transformTime(createdTime[1])
      }
      delete data.createdTime
      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.orderNo = ''
      that.queryParam.mobileNo = ''
      that.queryParam.aadhaarName = ''
      that.queryParam.createdTime = undefined
      that.queryParam.loanStatus = ''
      that.queryParam.approvalStatus = ''
      that.queryParam.settleStatus = ''
      // that.loadData(this.form.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
    handleDetail(row) {
      this.orderId = row.id
      this.custInfoId = row.custInfoId
      this.changeModal(true)
    },
    handleEdit(record) {
      console.log('点击了编辑-父')
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
    },
    handleClear(id) {
      clearOrderForTest({ id }).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    handleClearRedis(id) {
      console.log('点击了清除redis-父')
      clearRedisOrderData({ id }).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    showResetModal(id) {
      this.currentOrderId = id;
      this.resetModalVisible = true;
      this.orderNo = ""; // 清空之前的输入
      this.payoutId = ""
    },

    // 弹窗确认后调用接口
    handleResetConfirm() {
      if (!this.orderNo.trim()) {
        this.$message.warning("请输入原orderNo");
        return;
      }
      this.orderReset(this.currentOrderId, this.orderNo,this.payoutId);
    },

    // 调用重置接口
    orderReset(id, orderNo, payoutId) {
      this.resetModalVisible = false; // 关闭弹窗
      this.loading = true
      orderReset({ orderId: id, orderNo, payoutId}).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg);
          this.loadData();
        } else {
          this.$message.warning(res.msg);
        }
        this.loading = false
      });
    },

    showDeductionFeeModal(id) {
      this.currentOrderId = id;
      this.deductionFeeModalVisible = true;
      this.deductionFee = ""; // 清空之前的输入
    },

    // 弹窗确认后调用接口
    handleDeductionFeeConfirm() {
      if (!/^\d+(\.\d+)?$/.test(this.deductionFee)) {
        this.$message.warning("减免金额必须为有效数字");
        return;
      }
      this.orderDeductionFee(this.currentOrderId, this.deductionFee);
    },

    // 调用重置接口
    orderDeductionFee(id, deductionFee) {
      this.deductionFeeModalVisible = false; // 关闭弹窗
      this.loading = true
      orderDeductionFee({ orderId: id, deductionFee}).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg);
          this.loadData();
        } else {
          this.$message.warning(res.msg);
        }
        this.loading = false
      });
    },

    downLoadData(record, type) {
      console.log('record--->',record)
      console.log('type--->',type)
      // const file = {
      //   fileUrl: '/api/web/webpublic/order/test/getJsonData?orderId=' + record.id + '&type=' + type,
      //   fileName: 'jsonForCustExcel.txt'
      // }
      // this.loading = true
      // exportFile(file).catch(e => {
      //   this.$message.error(e.message)
      // }).finally(() => {
      //   this.loading = false
      // })
      // console.log('11111111111')
      getJsonData(Object.assign({}, { orderId:record.id,type:type })).then((res) => {
        console.log('getJsonData-----》', res)
        if (res.size == 0) {
          this.$message.error('暂无数据！')
        } else {
          // 创建可下载的URL地址
          const downloadUrl = URL.createObjectURL(res)
          // 创建a标签
          const a = document.createElement('a')
          a.href = downloadUrl
          // 设置要保存的文件名
          // a.download = 'document.xlsx'
          a.download = 'jsonForCustExcel.txt'
          // 模拟点击a标签，触发下载
          a.click()
          // 清理URL对象
          URL.revokeObjectURL(downloadUrl)
          this.$message.success('下载成功！')
          this.loadData(1)
        }

      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    // model回调
    modalFormOk() {
      this.loadData()
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
